import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../images/logo.png';

const Header = ({ isLoggedIn, handleLogout }) => {
    const [showUserMenu, setShowUserMenu] = useState(false);

    return (
        <header className="header">
            <div className="header-container">
                <Link to="/">
                    <img src={logo} alt="Psyche Gate logo" className="logo" />
                </Link>
                <nav>
                    <ul>
                        <li><a href="#!">For Individuals</a></li>
                        <li><a href="#!">For Businesses</a></li>
                        <li><a href="#!">Developers</a></li>
                    </ul>
                </nav>
                <div className="header-actions">
                    {isLoggedIn ? (
                        <div className="user-menu" onMouseEnter={() => setShowUserMenu(true)} onMouseLeave={() => setShowUserMenu(false)}>
                            <img src="https://i.pravatar.cc/40" alt="User Avatar" className="avatar" />
                            {showUserMenu && (
                                <div className="user-dropdown">
                                    <p>robinhood@gmail.com</p>
                                    <button onClick={handleLogout}>Logout</button>
                                </div>
                            )}
                        </div>
                    ) : (
                        <>
                            <a href="#!">Help</a>
                            <Link to="/login">Log In</Link>
                            <button>Get Started</button>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;